import {
  Button,
  CheckCircledIcon,
  Flex,
  Link,
  PoweredByAeropayLogo,
  Typography,
} from '@iheartjane/reefer';
import { useMemo } from 'react';

import { LoadingWrapper } from '@jane/shared/components';

export interface SuccessScreenProps {
  hasLinkedBank: boolean;
  hideBranding: boolean;
  loadingBanks: boolean;
  newUser: boolean;
  onLinkBank(): void;
  showJaneGold: boolean;
  showJanePay: boolean;
  storeName: string;
  userName: string;
}

export const SuccessScreen = ({
  hasLinkedBank,
  hideBranding,
  newUser,
  showJaneGold,
  showJanePay,
  storeName,
  loadingBanks,
  onLinkBank,
  userName,
}: SuccessScreenProps) => {
  const successMessage = useMemo(() => {
    return hasLinkedBank || (!showJaneGold && !showJanePay)
      ? 'Go back to the kiosk and start shopping!'
      : `You can go back to the kiosk and start shopping, but you need to link your bank account if you want to${
          showJaneGold ? ' earn cash back with Jane Gold' : ''
        }${showJaneGold && showJanePay ? ' and' : ''}${
          showJanePay
            ? ` shop faster ${
                !hideBranding ? ' with Jane Pay' : ''
              } at the kiosk`
            : ''
        }.`;
  }, [hasLinkedBank, showJaneGold, showJanePay, hideBranding]);

  return (
    <Flex
      flexDirection="column"
      gap={16}
      alignItems="center"
      justifyContent="center"
      p={24}
      height="100vh"
      width="100vw"
    >
      <CheckCircledIcon size="xxl" color="primary" />
      <Typography
        variant="title-bold"
        textAlign="center"
        width="inherit"
        px={24}
      >
        {newUser
          ? 'Welcome to Jane!'
          : userName?.includes('privaterelay.appleid.com')
            ? `Welcome to the kiosk at ${storeName}`
            : `${userName}, welcome to the kiosk at ${storeName}`}
      </Typography>

      <LoadingWrapper isLoading={loadingBanks}>
        <Typography textAlign="center">{successMessage}</Typography>
        {!hasLinkedBank && (showJaneGold || showJanePay) && (
          <>
            <Button
              full
              size="small"
              branded
              label="Link bank account"
              onClick={onLinkBank}
            />
            <Typography textAlign="center">
              By agreeing to link your bank, you agree to Aeropay’s{' '}
              <Link
                ariaLabel="link for Aeropay terms of service"
                href="https://www.aeropay.com/legal/terms-of-service"
              >
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link
                ariaLabel="link for Aeropay privacy policy"
                href="https://www.aeropay.com/legal/privacy-policy"
              >
                Privacy Policy
              </Link>
            </Typography>
            <PoweredByAeropayLogo height="24px" data-testid="aeropay-logo" />
          </>
        )}
      </LoadingWrapper>
    </Flex>
  );
};
